import React from 'react';
import {
  Collapse,
  TextTitle,
} from '@bingads-webui-campaign/wizard-jumbo-card';

export const getAdExtensionsSections = ({
  extensionTypes,
  extensionsAssociations,
  adExtensionsAssociationsFactory,
  adExtensionsDynamicFeatures = {},
  i18n,
  onUpdateExtensionsAssociations,
  campaign,
}) => adExtensionsAssociationsFactory.extensionsAssociationsFactory(campaign.Id, campaign.Name, extensionTypes, adExtensionsDynamicFeatures)
  .reduce((memo, {
    extensionType,
    title,
    topic,
    details,
    AssociationPanel,
  }) => {
    const sectionKey = extensionType;
    const associations = extensionsAssociations[extensionType];

    const panel = (
      <Collapse.Panel
        key={sectionKey}
        title={<TextTitle titleKey={title} topicKey={topic} details={details(i18n, associations)} />}
      >
        <AssociationPanel
          i18n={i18n}
          extensionsAssociations={extensionsAssociations}
          onUpdateExtensionsAssociations={onUpdateExtensionsAssociations}
        />
      </Collapse.Panel>

    );
    memo.panels.push(panel);
    memo.sectionsInfo.allSections.push(sectionKey);

    return memo;
  }, { panels: [], sectionsInfo: { allSections: [] } });
